module.exports = __webpack_public_path__ + "img/288w.b934da0.jpg";